var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCream = function SvgCream(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cream_svg__a)",
    d: "M183.928 102.12c-17-7.119-18.813-20.023-34.625-27.059C140.753 71.255 137.39 63 132.426 63c-3.971 0-9.259 6.865-12.906 11.055-21.327 24.507-35.74 17.086-49.24 38.117-9.584 14.929 37.553 16.082 45.459 14.072s57.744-5.2 62.472-2.6 22.517-14.488 5.717-21.524"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cream_svg__b)",
    d: "M236.991 119.467c-12.147-7.616-32.945-7.4-37.984-10.361s-14.437-17.843-25.3-14.288c-12.055 3.943-26.068.986-42.191.986s-3.014-13.8-21.1-13.8c-14.426 0-28.127 18.733-49.971 28.584-10.685 4.819 40.309 42.383 71.548 41.4 28.429-.9 107.006-16.739 107.006-28.57a4.5 4.5 0 0 0-2.008-3.951"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cream_svg__c)",
    d: "M33 119c10.326-7.687 36.213-10.669 40.233-12.638A18.5 18.5 0 0 1 81 105c9 0 21.759 1.615 26 3 6.031 1.969 21.046 11.517 33 6 13-6 24.7 2.207 28.719 4.176s12.061-4.922 30.153.985S224 131.96 224 131.96s-42.215 19.692-105.537 16.738c-54.376-2.536-88.468-14.7-88.463-24.7 0-1.998 1.225-3.677 3-4.998"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cream_svg__d)",
    d: "M135 140.646c53.559 0 114.127-12.158 101.928-21.646 11.139 7.922-3.1 15.321-12.55 30.913C209.1 175.083 182.489 207 135 207s-74.1-31.917-89.378-57.087c-9.45-15.592-23.689-22.991-12.55-30.913-12.199 9.488 48.369 21.646 101.928 21.646"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cream_svg__a",
    x1: 73.026,
    x2: 178.757,
    y1: 99.224,
    y2: 72.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.097,
    stopColor: "#268EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#449EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#75B8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#B9DAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cream_svg__b",
    x1: 69.079,
    x2: 192.871,
    y1: 118.826,
    y2: 90.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.097,
    stopColor: "#268EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#449EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#75B8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#B9DAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cream_svg__c",
    x1: 39.312,
    x2: 219.15,
    y1: 126.992,
    y2: 126.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#268EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#449EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#75B8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#B9DAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cream_svg__d",
    x1: 29,
    x2: 241,
    y1: 163,
    y2: 163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgCream;